import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { ReactComponent as CloseIcon } from '../../../assets/icons/close-circle.svg';
import { ReactComponent as NavigateArrow } from '../../../assets/icons/device-management/navigate-back.svg';
import { AvailableTabProperties } from '../../../interface/station-management-side-panel.interface';

interface StationManagementTabsProperties {
  containerTabs: AvailableTabProperties[];
  handleSwitchTab: (key: string) => void;
}

/**
 * Station Management Tabs
 * @returns
 */
function StationManagementTabs(properties: StationManagementTabsProperties) {
  const { t, i18n } = useTranslation('stationManagement');
  const navigate = useNavigate();
  const { containerTabs, handleSwitchTab } = properties;
  const location = useLocation();

  /**
   * Go back to parent
   */
  const goBackToParent = () => {
    const updated = location.pathname.replace(/\/station\/[^/]+\/[^/]+$/, '');
    if (window.history.length <= 1) {
      window.close();
      return;
    }
    navigate(updated);
  };

  return (
    <div className="station-container-tabs-wrap" dir={i18n.dir()}>
      <div className="navigate-arrow">
        <span role="presentation" onClick={goBackToParent}>
          <NavigateArrow />
        </span>
        <div className="navigate-background" />
      </div>
      <div className="title">
        <h1>{t('stationManagement')}</h1>
      </div>
      <div className="tabs-container">
        {containerTabs.map((tab) => (
          <div
            key={tab.key}
            className={`each-tab ${tab.isActive ? 'active' : ''}`}
            role="presentation"
            onClick={() => handleSwitchTab(tab.key)}>
            <span>{tab.label}</span>
          </div>
        ))}
      </div>
      <div className="close-icon">
        <span role="presentation" onClick={goBackToParent}>
          <CloseIcon />
        </span>
      </div>
    </div>
  );
}

export default StationManagementTabs;
